import React, { useState } from "react";
import { signInWithGoogle } from "./firebase";

export default function LoginScreen({ onLogin }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      const user = await signInWithGoogle();
      onLogin(user);
    } catch (e) {
      setError("Sign-in failed. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", background:"#C8D8EC", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans','Segoe UI',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet"/>
      <div style={{ width:"100%", maxWidth:400, padding:40, background:"white", border:"0.5px solid #D8DCE3", borderRadius:12, boxShadow:"0 8px 32px rgba(27,94,190,0.12)", textAlign:"center" }}>
        <div style={{ width:60, height:60, borderRadius:16, background:"#1B5EBE", display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, margin:"0 auto 20px" }}>🏠</div>
        <h1 style={{ fontSize:24, fontWeight:700, color:"#1A2B45", margin:"0 0 6px", fontFamily:"'DM Sans',sans-serif" }}>Dorcus Home</h1>
        <p style={{ fontSize:13, color:"#4A5568", margin:"0 0 32px", fontFamily:"'Inter',sans-serif" }}>Resident Management System</p>

        <button onClick={handleGoogleLogin} disabled={loading} style={{
          width:"100%", padding:"12px 20px", background:"#1B5EBE", color:"white", border:"none",
          borderRadius:8, fontSize:14, fontWeight:600, cursor:"pointer",
          display:"flex", alignItems:"center", justifyContent:"center", gap:10,
          opacity:loading?0.6:1, marginBottom:12, fontFamily:"'Inter',sans-serif",
        }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {loading ? "Signing in..." : "Sign in with Google"}
        </button>

        <p style={{ fontSize:11, color:"#4A5568", margin:0, fontFamily:"'Inter',sans-serif" }}>For Admin, Program Manager &amp; house computer accounts</p>

        {error && <p style={{ fontSize:12, color:"#8B1A1A", marginTop:16, margin:"16px 0 0", fontFamily:"'Inter',sans-serif" }}>{error}</p>}

        <div style={{ marginTop:28, paddingTop:24, borderTop:"1px solid #D8DCE3" }}>
          <p style={{ fontSize:11, color:"#4A5568", margin:"0 0 4px", fontFamily:"'Inter',sans-serif" }}>For authorized Dorcus staff only.</p>
          <p style={{ fontSize:11, color:"#4A5568", margin:0, fontFamily:"'Inter',sans-serif" }}>RAs: sign in on your house computer using the shared account, then enter your PIN.</p>
        </div>
      </div>
    </div>
  );
}
